import { Fields } from '@app/sharedModule/components/rules-dynamic-form/model';
import { RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { countryList } from '@pages/checkout-app/configs';

const now = new Date();
export const BlackoutDatesRules = [
  {
    entity: RuleEntity.CUSTOM_BLACKOUT_DATES,
    entityOperator: null,
    entityConfig: {
      maximumDate: new Date(now.getFullYear() + 1, now.getMonth(), now.getDate()),
    },
    entityParams: [
      {
        required: true,
        name: 'startDateValue',
        defaultValue: '',
      },
      {
        name: 'endDateValue',
        defaultValue: '',
      },
    ],
  },
  {
    entity: RuleEntity.HOLIDAY,
    entityOperator: null,
    entityParams: [
      {
        required: true,
        name: 'holidaysValue',
        defaultValue: '',
        fieldType: Fields.DROP_DOWN,
        options: countryList('label'),
      },
    ],
  },
  {
    entity: RuleEntity.WEEKDAY_GEO_FENCE,
    entityOperator: null,
    entityParams: [
      {
        required: true,
        name: 'weekdaysValue',
        defaultValue: '',
      },
      {
        required: true,
        name: 'deliveryArea',
        defaultValue: '',
      },
      {
        required: true,
        name: 'deliveryAreaOperator',
        defaultValue: '',
      },
      {
        required: true,
        name: 'deliveryAreaValue',
        defaultValue: '',
      },
    ],
  },
  // {
  //   entity: RuleEntity.WEEKEND,
  //   entityOperator: null,
  //   entityParams: [
  //     {
  //       name: 'weekendsValue',
  //       defaultValue: '',
  //       fieldType: Fields.DROP_DOWN,
  //       required: true,
  //       options: [
  //         {
  //           label: 'Saturday - Sunday',
  //           value: DatePickerExtension.WeekendTypes.SAT_SUN,
  //         },
  //         {
  //           label: 'Friday - Saturday',
  //           value: DatePickerExtension.WeekendTypes.FRI_SAT,
  //         },
  //       ],
  //     },
  //   ],
  // },
];
